'use strict';

(function () {
  'use strict';

  angular.module('msSleep').service('sleepCheckInSvc', SleepCheckInSvc);

  SleepCheckInSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function SleepCheckInSvc(httpSvc) {
    this.saveCheckIn = saveCheckIn;

    function saveCheckIn(checkIn) {
      return httpSvc.post('/apiproxy/user/sleep/checkin/', checkIn);
    }
  }
})();